export default "/assets/website/images/instagram.png?a4d4db8b79de7f8d82562fbfca1e167f";